/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import { type InstrumentationConfig } from '@opentelemetry/instrumentation'

import { LONG_ANIMATION_FRAME_PERFORMANCE_TYPE } from './constants'

export function isLongAnimationFrameSupported(
	supportedEntryTypes: readonly string[] = window.PerformanceObserver?.supportedEntryTypes ?? [],
): boolean {
	return supportedEntryTypes.includes(LONG_ANIMATION_FRAME_PERFORMANCE_TYPE)
}

export function isLoafInstrumentationEnabled(config?: boolean | InstrumentationConfig): boolean {
	if (config === undefined || config === false) {
		return false
	}

	if (typeof config === 'object' && config.enabled === false) {
		return false
	}

	return true
}
